export enum AppScopes {
  ADMIN                       = 'admin',
  AUTOMATIC_EMAILS            = 'automatic_emails',
  CASE_MANAGEMENT_MASTER      = 'case_management_master',
  DASH_BOARD                  = 'dash_board',
  WORKLOAD                    = 'cm_dashboard',
  DEFAULT_USER                = 'default_user',
  EMPLOYEE_ACTIONS            = 'employee_actions',
  ERGO_TEAM_MANAGEMENT        = 'ergo_team_management',
  ERGO_WORKFLOW               = 'ergo_workflow',
  EVAL_EDIT                   = 'eval_edit',
  EXECUTIVE_SUMMARY           = 'executive_summary',
  FULL_ACCESS                 = 'full_access',
  GAP_ASSESSMENT              = 'gap_report',
  INDICATORS_REPORT           = 'indicators_report',
  PERSONAL_DASHBOARD          = 'personal_dashboard',
  PROFILE_EDIT                = 'profile_edit',
  ROI                         = 'roi_report',
  USER_PROFILE                = 'user_profile',
  TRAINING_CONFIG             = 'training_config',
  EQUIPMENT_CONFIG            = 'equipment_lib',
  NOTIFICATIONS_CONFIG        = 'email_templates',
  IMPORT_DATA_CONFIG          = 'import_users',
  SITE_SETTINGS               = 'summary',
  RECOMMENDATIONS_CONFIG      = 'ergo_recommendations',
  MYZONE_EQUIPMENT_PERMISSION = 'myzone_equipment',
  EMPLOYEE_TRAINING_ACCESS    = 'employee_training',
  SURVEY_SELF_START           = 'survey_self_start',
  UPDATE_USER_ROLE            = 'update_user_roles',
  DELETE_USER                 = 'user_delete',
  ASSESSMENT_CONFIG           = 'questions_display',
  ASSESSMENT_RESULTS          = 'survey_result',
  ACTIVITY_REPORT             = 'activity_report',
  ROLE_PERMISSION             = 'role_permission',
}
